import { defineStore } from 'pinia'
import { ref } from 'vue'

import products from '@/store/products'
import { AuthProductName, ViewName, type ProductConfig } from '@/types'
import { useAuthStore } from './AuthStore'
export const useProductStore = defineStore('ProductStore', () => {
  const product = ref<ProductConfig>({
    id: '',
    name: '',
    viewDecorations: [
      {
        allowCreate: true,
        badgeText: '',
        viewName: ViewName.Login,
        offerMessage: '',
        title: 'Log in to your account',
        body: 'Enter the email address associated with your Output account.'
      },
      {
        badgeText: '',
        viewName: ViewName.Success,
        offerMessage: '',
        title: "You're logged in!",
        body: 'Now visit output.com'
      }
    ],
    authProductName: AuthProductName.WEBSITE
  })

  const setProduct = (productId: string) => {
    const productState = products.find(item => item.id === productId)

    if (!productState) {
      return
    }

    const { authProductName } = productState
    const { setAuthProductName } = useAuthStore()

    if (productState) {
      product.value = {
        ...productState
      }
    }

    if (authProductName) {
      setAuthProductName(authProductName)
    }
  }

  const getAppReturnLink = (referrer: string): string | undefined => {
    return product.value.appReturnLinks?.get(referrer)
  }

  return { product, setProduct, getAppReturnLink }
})
